import { Button } from 'react-bootstrap';

const DiscoveryEmptyState = ({
    icon,
    title,
    description,
    primaryAction,
    secondaryAction,
    className = '',
}) => {
    const actions = [primaryAction, secondaryAction].filter(Boolean);

    return (
        <div className={`discovery-empty-state ${className}`.trim()}>
            {icon && (
                <div className="discovery-empty-state__icon" aria-hidden="true">
                    <img src={icon} alt="" />
                </div>
            )}

            <h3 className="discovery-empty-state__title">{title}</h3>
            <p className="discovery-empty-state__description">{description}</p>

            {actions.length > 0 && (
                <div className="discovery-empty-state__actions">
                    {actions.map((action) => (
                        <Button
                            key={action.label}
                            type="button"
                            variant={action.variant || 'outline-secondary'}
                            className="discovery-empty-state__action"
                            onClick={action.onClick}
                        >
                            {action.label}
                        </Button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DiscoveryEmptyState;
